import { useState, useEffect } from 'react';
import Login from './pages/Login';
import Onboarding from './pages/Onboarding';
import Overview from './pages/Overview';
import Webhooks from './pages/Webhooks';
import Config from './pages/Config';
import Canales from './pages/Canales';
import Tokens from './pages/Tokens';
import Billing from './pages/Billing';
import Sidebar from './components/Sidebar';
import Admin from './pages/Admin';
import Conversaciones from './pages/Conversaciones';
import { getPermisos } from './services/permisos';
import Soporte from './pages/Soporte';
import AdminTickets from './pages/AdminTickets';
import Calendario from './pages/Calendario';
import Social from './pages/Social';
import SeoPresencia from './pages/SeoPresencia';   // ← NUEVO
import Academia from './pages/Academia';
import './index.css';
import Propiedades from './pages/Propiedades';
import Cualificacion from './pages/Cualificacion';
import Leads from './pages/Leads';
import Health from './pages/Health';
import JobOffers from './pages/JobOffers';
import Candidates from './pages/Candidates';
import Productos from './pages/Productos';



const ADMIN_EMAIL = 'jpatinop@gmail.com';

function UpsellModal({ plan, onClose }) {
  const esPresencia = plan === 'presencia' || plan === 'presencia_anual';
  const c = esPresencia ? {
    emoji: '💬',
    titulo: '¿Listo para hablar con tus clientes?',
    sub: 'Añade un agente de IA que responde 24/7 por WhatsApp y en tu web.',
    items: ['💬 Widget de chat en tu página web', '📱 WhatsApp Business integrado', '📋 Gestión de conversaciones y leads', '📅 Reservas y citas automáticas'],
    plan: 'Conversación', precio: '107€/mes',
  } : {
    emoji: '🚀',
    titulo: 'Activa el plan completo',
    sub: 'Publicador social con IA y páginas SEO que posicionan tu negocio en Google.',
    items: ['📣 Publicador Social IA (LinkedIn, Facebook, Instagram)', '🔍 Páginas SEO programáticas', '🎓 Devit Academy para tu equipo', '✅ Todo lo que ya tienes incluido'],
    plan: 'Autónomo', precio: '174€/mes',
  };
  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.72)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999,padding:'20px'}} onClick={onClose}>
      <div style={{background:'#12141f',border:'1px solid #2a2e4a',borderRadius:'16px',padding:'36px 32px',maxWidth:'420px',width:'100%',position:'relative'}} onClick={e=>e.stopPropagation()}>
        <button onClick={onClose} style={{position:'absolute',top:'14px',right:'16px',background:'none',border:'none',color:'#5a5e82',fontSize:'20px',cursor:'pointer',lineHeight:1}}>✕</button>
        <div style={{fontSize:'34px',marginBottom:'10px'}}>{c.emoji}</div>
        <h2 style={{color:'#f0f0ff',fontSize:'19px',fontWeight:'800',margin:'0 0 8px'}}>{c.titulo}</h2>
        <p style={{color:'#9b9fc4',fontSize:'13px',margin:'0 0 20px',lineHeight:'1.5'}}>{c.sub}</p>
        <ul style={{listStyle:'none',padding:0,margin:'0 0 24px'}}>
          {c.items.map(i=>(
            <li key={i} style={{color:'#c4c6e0',fontSize:'13px',padding:'6px 0',borderBottom:'1px solid #1e2035'}}>{i}</li>
          ))}
        </ul>
        <a href="/contratar" style={{display:'block',background:'#7c4dff',color:'#fff',padding:'11px 20px',borderRadius:'8px',textDecoration:'none',fontWeight:'700',fontSize:'14px',textAlign:'center'}}>
          Ver plan {c.plan} — {c.precio} →
        </a>
        <p style={{color:'#5a5e82',fontSize:'11px',marginTop:'10px',textAlign:'center'}}>Sin permanencia · Cancela cuando quieras</p>
      </div>
    </div>
  );
}

export default function App() {
  const [page, setPage] = useState('login');
  const [tenant, setTenant] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showUpsell, setShowUpsell] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('devit_token');
    if (token) {
      fetch('https://bot.devit.es/api/tenants/me', {
        headers: { 'Authorization': `Bearer ${token}` }
      })
        .then(r => r.json())
        .then(async data => {
          setTenant(data);

          // ── Plan pendiente desde el landing (/contratar?plan=xxx) ──────────
          // Si el usuario llegó desde el landing con un plan seleccionado,
          // lanzamos el checkout automáticamente tras autenticarse
          const planPendiente = localStorage.getItem('devit_plan_pendiente');
          if (planPendiente) {
            localStorage.removeItem('devit_plan_pendiente');
            try {
              const res = await fetch('https://bot.devit.es/api/billing/checkout', {
                method: 'POST',
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({ plan: planPendiente }),
              });
              const d = await res.json();
              if (d.checkout_url) {
                window.location.href = d.checkout_url;
                return; // no seguir — el usuario va a Stripe
              }
            } catch {
              // Si falla el checkout, caemos al overview normalmente
            }
          }
          // ─────────────────────────────────────────────────────────────────

          // ── Onboarding wizard ──
          const planesConWizard = ['conversacion', 'conversacion_anual', 'autonomo', 'autonomo_anual', 'presencia', 'presencia_anual'];
          if (planesConWizard.includes(data.plan) && !data.onboarding_completado) {
            setPage('onboarding');
          } else {
            setPage('overview');
          }
          // ─────────────────────────────────────────────────────────────────
        })
        .catch(() => localStorage.removeItem('devit_token'));
    }
  }, []);

  // ← NUEVO: escuchar evento de navegación que emite Social.jsx
  useEffect(() => {
    const handler = (e) => { setPage(e.detail); setSidebarOpen(false); };
    window.addEventListener('navigate', handler);
    return () => window.removeEventListener('navigate', handler);
  }, []);

  const handleLogin = (tenantData, token, destino = 'overview') => {
    localStorage.setItem('devit_token', token);
    setTenant(tenantData);
    const planesConWizard = ['conversacion', 'conversacion_anual', 'autonomo', 'autonomo_anual', 'presencia', 'presencia_anual'];
    if (planesConWizard.includes(tenantData.plan) && !tenantData.onboarding_completado) {
      setPage('onboarding');
    } else {
      setPage(destino);
      const planesUpsell = ['presencia', 'presencia_anual', 'conversacion', 'conversacion_anual'];
      if (planesUpsell.includes(tenantData.plan) && tenantData.onboarding_completado && tenantData.email !== ADMIN_EMAIL && !tenantData.en_trial) {
        setTimeout(() => setShowUpsell(true), 1200);
      }
    }
  };

  const handleNavigate = (p) => { setPage(p); setSidebarOpen(false); };

  const handleLogout = () => {
    localStorage.removeItem('devit_token');
    setTenant(null);
    setPage('login');
  };

   const isAdmin = tenant?.email === ADMIN_EMAIL;
   const permisos = getPermisos(tenant?.plan);

  if (page === 'login') {
    return <Login onLogin={handleLogin} />;
  }

  // Onboarding wizard — pantalla completa, sin sidebar
  if (page === 'onboarding') {
    const esPresenciaWizard = ['presencia', 'presencia_anual'].includes(tenant?.plan);
    return (
      <Onboarding
        tenantId={tenant?.tenant_id}
        plan={tenant?.plan}
        onComplete={() => {
          setTenant(t => ({ ...t, onboarding_completado: true }));
          setPage(esPresenciaWizard ? 'seo' : 'overview');
        }}
      />
    );
  }

  const pages = {
    overview:       <Overview />,
    webhooks:       <Webhooks permisos={permisos} onUpgrade={() => setPage('billing')} />,
    config:         <Config permisos={permisos} onUpgrade={() => setPage('billing')} />,
    canales:        <Canales permisos={permisos} />,
    tokens:         <Tokens permisos={permisos} onUpgrade={() => setPage('billing')} />,
    conversaciones: <Conversaciones permisos={permisos} onUpgrade={() => setPage('billing')} />,
    billing:        <Billing onNavigate={setPage} plan={tenant?.plan} />,
    soporte:        <Soporte />,
    calendario:     <Calendario />,
    social:         <Social />,   // ← NUEVO
    seo:            <SeoPresencia />,
    academia:       <Academia />,
    propiedades:    <Propiedades />,
    cualificacion:  <Cualificacion />,
    leads:          <Leads />,
    ofertas:    <JobOffers />,
    candidatos: <Candidates />,
    productos:   <Productos />,
    ...(isAdmin && { admin: <Admin />, admintickets: <AdminTickets />, health: <Health /> }),
  };

  // Trial expirado — pantalla de upgrade
  const trialExpirado = tenant?.trial_hasta && !tenant?.en_trial && !tenant?.plan;
  if (trialExpirado) {
    return (
      <div style={{minHeight:'100vh',background:'#0d0f1a',display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}>
        <div style={{maxWidth:'560px',width:'100%',background:'#12141f',border:'1px solid #2a2e4a',borderRadius:'16px',padding:'40px 36px',textAlign:'center'}}>
          <div style={{fontSize:'40px',marginBottom:'12px'}}>⏰</div>
          <h2 style={{color:'#f0f0ff',fontSize:'22px',fontWeight:'800',margin:'0 0 8px'}}>Tu prueba gratuita ha terminado</h2>
          <p style={{color:'#9b9fc4',fontSize:'15px',margin:'0 0 28px',lineHeight:'1.6'}}>Todo lo que configuraste sigue guardado. Elige un plan para recuperar el acceso al instante.</p>
          <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'12px',marginBottom:'28px'}}>
            {[
              {nombre:'Presencia',precio:'59€/mes',desc:'Publicador Social IA + Páginas SEO'},
              {nombre:'Autónomo',precio:'174€/mes',desc:'Todo Presencia + Agente WhatsApp + Web',destacado:true},
              {nombre:'Conversación',precio:'107€/mes',desc:'Agente WhatsApp + Widget Web'},
            ].map(p => (
              <div key={p.nombre} style={{background:p.destacado?'#1e1542':'#1a1c2e',border:`1px solid ${p.destacado?'#7c4dff':'#2a2e4a'}`,borderRadius:'10px',padding:'14px 10px'}}>
                <div style={{fontWeight:'800',fontSize:'13px',color:p.destacado?'#a78bfa':'#f0f0ff',marginBottom:'4px'}}>{p.nombre}</div>
                <div style={{fontSize:'15px',fontWeight:'700',color:'#f0f0ff',marginBottom:'6px'}}>{p.precio}</div>
                <div style={{fontSize:'11px',color:'#9b9fc4',lineHeight:'1.4'}}>{p.desc}</div>
              </div>
            ))}
          </div>
          <a href="/contratar" style={{display:'inline-block',background:'#7c4dff',color:'#fff',padding:'13px 32px',borderRadius:'8px',textDecoration:'none',fontWeight:'700',fontSize:'15px'}}>Elegir mi plan →</a>
          <p style={{color:'#5a5e82',fontSize:'12px',marginTop:'16px'}}>Sin permanencia · Cancela cuando quieras · IVA incluido</p>
        </div>
      </div>
    );
  }

  // Banner trial activo
  const bannerTrial = tenant?.en_trial ? (
    <div style={{
      background: tenant.dias_trial_restantes <= 1 ? '#1e1010' : '#0f1428',
      borderBottom: `1px solid ${tenant.dias_trial_restantes <= 1 ? '#7f1d1d' : '#2a2e4a'}`,
      padding: '10px 20px', display: 'flex', alignItems: 'center',
      justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px'
    }}>
      <span style={{fontSize:'13px', color: tenant.dias_trial_restantes <= 1 ? '#fca5a5' : '#9b9fc4'}}>
        {tenant.dias_trial_restantes <= 1
          ? '⚠️ Tu prueba gratuita termina hoy — elige un plan para no perder el acceso'
          : `🎯 Prueba gratuita — te quedan ${tenant.dias_trial_restantes} días`}
      </span>
      <a href="/contratar" style={{background:'#7c4dff',color:'#fff',padding:'5px 14px',borderRadius:'6px',textDecoration:'none',fontSize:'12px',fontWeight:'700',whiteSpace:'nowrap'}}>Elegir plan →</a>
    </div>
  ) : null;

  return (
    <div style={{ display: 'flex', minHeight: '100vh', flexDirection: 'column' }}>
      {bannerTrial}
      <div style={{ display: 'flex', flex: 1 }}>
        {sidebarOpen && <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)} />}
        <Sidebar
          current={page}
          open={sidebarOpen}
          onNavigate={handleNavigate}
          onLogout={handleLogout}
          tenant={tenant}
          isAdmin={isAdmin}
          permisos={permisos}
        />
        <div style={{ flex: 1, overflow: 'auto' }}>
          <button className="menu-btn" onClick={() => setSidebarOpen(o => !o)}>☰</button>
          {pages[page] || <Overview />}
        </div>
      </div>
      {showUpsell && <UpsellModal plan={tenant?.plan} onClose={() => setShowUpsell(false)} />}
    </div>
  );
}